
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.591 3.58a.5.5 0 01.818 0l1.098 1.559a.5.5 0 00.619.166l1.73-.801a.5.5 0 01.708.409l.171 1.899a.5.5 0 00.453.453l1.9.171a.5.5 0 01.408.708l-.8 1.73a.5.5 0 00.165.62l1.559 1.097a.5.5 0 010 .818l-1.559 1.098a.5.5 0 00-.166.619l.801 1.73a.5.5 0 01-.409.708l-1.899.171a.5.5 0 00-.453.453l-.171 1.9a.5.5 0 01-.708.408l-1.73-.8a.5.5 0 00-.62.165L12.41 20.42a.5.5 0 01-.818 0l-1.098-1.559a.5.5 0 00-.619-.166l-1.73.801a.5.5 0 01-.708-.409l-.171-1.899a.5.5 0 00-.453-.453l-1.9-.171a.5.5 0 01-.408-.708l.8-1.73a.5.5 0 00-.165-.62L3.58 12.41a.5.5 0 010-.818l1.559-1.098a.5.5 0 00.166-.619l-.801-1.73a.5.5 0 01.409-.708l1.899-.171a.5.5 0 00.453-.453l.171-1.9a.5.5 0 01.708-.408l1.73.8a.5.5 0 00.62-.165L11.59 3.58z","fill":"#FFDF34"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"5.5","fill":"#C4C4C4"}}),_c('circle',{attrs:{"cx":"12","cy":"12","r":"5.5","fill":"url(#paint0_linear)"}}),_c('path',{attrs:{"d":"M12.142 6.502a5.358 5.358 0 00-1.589.193c-.258.072-.311.421-.08.556a5.53 5.53 0 012.732 4.767 5.531 5.531 0 01-2.732 4.767c-.23.135-.179.484.08.556.458.127.939.195 1.435.195 3.02-.006 5.534-2.532 5.518-5.557-.026-2.92-2.444-5.388-5.364-5.477z","fill":"#FFEB81"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear","x1":".599","y1":"21.353","x2":"16.882","y2":"3.699","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FF4747"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFF200"}})])])])
          )
        }
      }
    